(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    class AgeGate extends HTMLElement {
    static STORAGE_KEY = 'dwatx_age_verified_v1';
    static STORAGE_VALUE = '21';

    connectedCallback() {
      try {
        if (localStorage.getItem(AgeGate.STORAGE_KEY) === AgeGate.STORAGE_VALUE) {
          this.remove();
          return;
        }
      } catch (e) {}

      this.hidden = false;

      this.querySelector('[data-age-gate-confirm]')?.addEventListener('click', () => this.confirm());
      this.querySelector('[data-age-gate-deny]')?.addEventListener('click', () => this.deny());
      this.querySelector('[data-age-gate-reset]')?.addEventListener('click', () => this.reset());
    }

    confirm() {
      try {
        localStorage.setItem(AgeGate.STORAGE_KEY, AgeGate.STORAGE_VALUE);
      } catch (e) {}
      this.remove();
    }

    deny() {
      this.querySelector('[data-age-gate-prompt]').hidden = true;
      this.querySelector('[data-age-gate-rejected]').hidden = false;
    }

    reset() {
      this.querySelector('[data-age-gate-prompt]').hidden = false;
      this.querySelector('[data-age-gate-rejected]').hidden = true;
    }
  }

  if (!customElements.get('age-gate')) {
    customElements.define('age-gate', AgeGate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    // Hover-preview enhancer for mega menus.
  // Finds every <ul.mega-menu__list> on the page, injects a floating preview
  // pane into its closest positioned ancestor, and swaps the image when a
  // link with [data-mm-image] is hovered.
  (() => {
    function setup(list) {
      if (list.dataset.mmPreviewReady) return;
      list.dataset.mmPreviewReady = '1';

      const container = list.closest('.mega-menu, .submenu, .header__submenu, .menu-list__submenu') || list.parentElement;
      if (!container) return;
      const cs = getComputedStyle(container);
      if (cs.position === 'static') container.style.position = 'relative';

      const preview = document.createElement('div');
      preview.className = 'mega-menu__preview';
      preview.setAttribute('aria-hidden', 'true');
      const img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      preview.appendChild(img);
      container.appendChild(preview);

      const show = (src) => {
        if (!src) return;
        if (img.src !== src) img.src = src;
        preview.classList.add('is-active');
      };
      const hide = () => preview.classList.remove('is-active');

      list.querySelectorAll('a[data-mm-image]').forEach((a) => {
        a.addEventListener('mouseenter', () => show(a.dataset.mmImage));
        a.addEventListener('focus', () => show(a.dataset.mmImage));
      });
      list.addEventListener('mouseleave', hide);
      list.addEventListener('focusout', (e) => {
        if (!list.contains(e.relatedTarget)) hide();
      });
    }

    const init = () => document.querySelectorAll('ul.mega-menu__list').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Shopify Section Rendering re-injects menus — re-run on DOM mutations.
    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-dropdown"] && !Shopify.designMode) return;
  try {
    class SearchDropdown extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[ref="searchButton"]');
      this.panel = this.querySelector('[ref="searchPanel"]');
      this.input = this.querySelector('[ref="searchInput"]');
      this.isOpen = false;

      if (!this.button || !this.panel) return;

      this._onButtonClick = this._onButtonClick.bind(this);
      this._onOutsideClick = this._onOutsideClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      this.button.addEventListener('click', this._onButtonClick);
      document.addEventListener('click', this._onOutsideClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this._onButtonClick);
      document.removeEventListener('click', this._onOutsideClick);
      document.removeEventListener('keydown', this._onKeydown);
    }

    _onButtonClick(event) {
      event.stopPropagation();
      this.toggle();
    }

    _onOutsideClick(event) {
      if (!this.isOpen) return;
      if (!this.contains(event.target)) this.close();
    }

    _onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.button.focus();
      }
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.setAttribute('data-open', 'true');
      this.button.setAttribute('aria-expanded', 'true');
      this.panel.setAttribute('aria-hidden', 'false');
      setTimeout(() => this.input?.focus(), 120);
    }

    close() {
      this.isOpen = false;
      this.removeAttribute('data-open');
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
    }
  }

  if (!customElements.get('search-dropdown')) {
    customElements.define('search-dropdown', SearchDropdown);
  }
  } catch(e) { console.error(e); }
})();

})();
